import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_present";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
